<template>
  <div>
    <h3 class="topTitle">Ruta del vehículo <b class="green">{{patent}}</b></h3>
    <div v-if="routeExists">
      <el-tabs v-model="activeNameSecond">
        <el-tab-pane label="Mapa" name="first">
          <div class="map-box">
            <MapRoutes
              v-loading="load"
              slot="map"
              :oneRoute="true"
              :locations="routeData"
              :height="'300px'"
              :scrollWheel="false"></MapRoutes>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Puntos de entrega" name="second">
          <div class="table smallerTag smallerTable">
            <DriverTable
              v-loading="load"
              :suborderDetail="false"
              :tableData="deliveryPoints"/>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div v-else>
      <NotFound
        imgName="fb-map.svg"
        textGreen="No se encontro ruta activa"
        textGrey="para la patente" />
    </div>
  </div>
</template>

<script>
import DriverTable from './TracingDriverTable.vue';
import MapRoutes from './maps/MapRoutes.vue';
import NotFound from './Base404.vue';

export default {
  name: 'TracingEnterpriseSelectdRoute',
  components: {
    DriverTable,
    MapRoutes,
    NotFound,
  },
  props: {
    route: {
      type: Object,
    },
    patent: {
      type: String,
    },
    load: {
      type: Boolean,
    },
    routeExists: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      deliveryPoints: [],
      routesOrdenadas: [],
      activeNameSecond: 'first',
      routeData: [],
    };
  },
  methods: {
    routePosition(a, b) {
      if (b.route_position === null && a.route_position !== null) {
        return -1;
      } if (a.route_position === null && b.route_position !== null) {
        return 1;
      } if (a.route_position > b.route_position) {
        return 1;
      } if (b.route_position > a.route_position) {
        return -1;
      } if (b.route_position === null && a.route_position === null) {
        return 0;
      }
      return 0;
    },
    set() {
      this.activeNameSecond = 'first';
      this.routeData = [this.route];
      this.deliveryPoints = this.route.delivery_points;
      this.deliveryPoints = this.deliveryPoints.sort((a, b) => this.routePosition(a, b));
    },
  },
  watch: {
    route() {
      this.set();
    },
  },
};
</script>

<style lang="scss" scoped>
  .topTitle {
    text-transform: uppercase;
    font-size: 16px;
    text-align: left;
    margin: 0 0 5px;
  }
  .map-box {
     margin-top: 1em;
   }
  .green {
    color: $fb-green;
  }

</style>
